export default __webpack_public_path__ + "static/media/infoBackground.f0cf77b2.jpg";